import { Component, OnInit, NgZone } from "@angular/core";
import { FormBuilder, Validators, FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "src/app/core-services/auth.service";
import { first } from "rxjs/operators";
import { LoginVM } from "src/app/models/Registration";
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from "ngx-spinner";
import { UserRole } from "src/app/Enum/Enum";
import { HttpClient } from "@angular/common/http";
import { DeviceDetectorService } from 'ngx-device-detector';
// import { UniqueDeviceID } from "@ionic-native/unique-device-id/ngx";
declare global {
    interface Window {
      RTCPeerConnection: RTCPeerConnection;
      mozRTCPeerConnection: RTCPeerConnection;
      webkitRTCPeerConnection: RTCPeerConnection;
    }
  }

@Component({
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
    error: any;
    returnUrl: string;
    // loading = false;
    submitted = false;
    loginForm: FormGroup;
    Formdata: any = {};
    deviceInfo = null;
    registerUrl: string;
    emailPattern = /^([\w-\.]+\u0040([\w-]+\.)+[\w-]{2,4})?$/;
    private ipRegex = new RegExp(/([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/);

    constructor(
          private fb: FormBuilder
        , private router: Router
        // , private uniqueDeviceID: UniqueDeviceID
        , private zone: NgZone
        , private authenticationService: AuthService
        , private toastr: ToastrService
        , private cookieService: CookieService
        , private spinner: NgxSpinnerService
        , private http: HttpClient
        , private deviceService: DeviceDetectorService) {

        // redirect to home if already logged in
        this.registerUrl =  window.location.origin + '/signup';
        var currentUser = localStorage.getItem('currentUser');
        if (currentUser != null && currentUser != undefined) {
            this.router.navigate(['/searchresultsplash']);
        }

        this.epicFunction();
    }

    ngOnInit() {
        // get return url from route parameters or default to '/'
        // this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
        this.loginForm = this.fb.group({
            userName: ['', [Validators.required, Validators.email]],
            password: ['', [Validators.required,  Validators.pattern('^.{8,}$')]],
            remember: [false]
        });

        if (this.cookieService.get('remember')) {
            this.loginForm.controls.userName.setValue(this.cookieService.get('userName'));
            this.loginForm.controls.password.setValue(this.cookieService.get('password'));
            this.loginForm.controls.remember.setValue(this.cookieService.get('remember'));
        }
    }

    // get f() { return this.loginForm.controls; }

    public hasError = (controlName: string, errorName: string) => {
        return this.loginForm.controls[controlName].hasError(errorName);
    }

    // showResponse(event) {
    //      this.messageService.add({ severity: 'info', summary: 'Succees', detail: 'User Responded', sticky: true });
    // }

    // convenience getter for easy access to form fields

    Login() {
        this.submitted = true;
        if (this.loginForm.invalid) {
            if (this.loginForm.controls.password.value != null && this.loginForm.controls.password.value != '') {
                this.toastr.warning('Passwords must contain at least eight characters.', 'Oops !');
            }
            return;
        }
        this.cookieService.deleteAll();
        // store values in cookies
        if (this.loginForm.controls.remember.value == true || this.loginForm.controls.remember.value == 'true') {
            this.cookieService.set('userName', this.loginForm.controls.userName.value);
            this.cookieService.set('password', this.loginForm.controls.password.value);
            this.cookieService.set('remember', this.loginForm.controls.remember.value);
        }
        let model: LoginVM;
        model = this.loginForm.value;
        // this.loading = true;
        this.spinner.show();
        this.authenticationService.login(model).pipe(first()).subscribe((response: any) => {
            if (response != null && response != null && response.isSuccess == true) {
                this.spinner.hide();
                if (response.usersDetailsVM != null && response.usersDetailsVM.userRole != null && response.usersDetailsVM.userRole != '') {
                    if (response.usersDetailsVM.userRole == UserRole.SuperAdmin) {
                       this.router.navigate(['/searchresultsplash']);
                    }
                    else {
                        if (response.usersDetailsVM.planId != null && response.usersDetailsVM.planId > 0) {
                           this.router.navigate(['/searchresultsplash']);
                        }
                        else {
                            this.router.navigate(['/planselection']);
                        }
                    }
                }
            }
            else {
                // this.loginForm.reset();
                this.toastr.warning(response.message);
                this.spinner.hide();
                // this.toastr.warning('Invalid Username or Password', 'Oops !');
            }
        },
            error => {
                this.spinner.hide();
                this.error = error;
                // this.loading = false;
            });
    }

    epicFunction() {
        this.deviceInfo = this.deviceService.getDeviceInfo();
        const isMobile = this.deviceService.isMobile();
        const isTablet = this.deviceService.isTablet();
        const isDesktopDevice = this.deviceService.isDesktop();
  }
}
